import { Mail, MessageCircle, Linkedin, Check } from 'lucide-react'

const PROOF = [
  'Won the largest regional startup competition',
  'Raised $200K',
  'Partnered with 75+ clinics in Eastern Europe',
  '1,500+ preorders',
  'Team of addiction clinicians, PhD neuroscientists and SaaS operators',
]

const LINKS = [
  { name: 'WhatsApp', icon: MessageCircle, href: 'https://wa.me/995551234567' },
  { name: 'LinkedIn', icon: Linkedin, href: 'https://www.linkedin.com/company/betterstep' },
  { name: 'investors@betterstep.io', icon: Mail, href: 'mailto:investors@betterstep.io' },
]

function ContactPage() {
  return (
    <div className="screen screen--ink">
      <header className="topbar">
        <img src="/images/logo.svg" alt="" className="logo-mark" style={{ marginLeft: 6 }} />
        <span className="topbar__label">BetterStep</span>
        <span />
      </header>
      <main className="contact">
        <div className="flow__head">
          <h1 className="contact__title">70% of rehab patients relapse within a year. We can predict it before it happens.</h1>
          <p className="contact__lede">BetterStep uses wearables and AI to detect relapse risk from heart-rate variability, sleep and stress.</p>
        </div>

        <div>
          <h2 style={{ marginBottom: 14 }}>Let’s meet before you meet us in every clinic.</h2>
          <div className="contact__links">
            {LINKS.map((l) => {
              const Icon = l.icon
              return (
                <a key={l.name} className="btn btn--ghost-on-ink" href={l.href} target="_blank" rel="noopener noreferrer">
                  <Icon size={16} strokeWidth={2} />
                  {l.name}
                </a>
              )
            })}
          </div>
        </div>

        <ul className="contact__proof" aria-label="Traction">
          {PROOF.map((p) => (
            <li key={p}><Check size={16} strokeWidth={2.5} />{p}</li>
          ))}
        </ul>
      </main>
    </div>
  )
}

export default ContactPage
